/* eslint-disable no-invalid-this */

import {STATUS} from '../constants';

const initAudioPlayer = () => {
  const audioPlayer = document.querySelector('[data-audio-player]');

  if (!audioPlayer) {
    return;
  }

  const startBtn = document.querySelector('[data-player-start]');
  const allTracks = audioPlayer.querySelectorAll('.track[data-track-id]');
  const allAudios = audioPlayer.querySelectorAll('audio[data-track-id]');

  function startListenAlbum() {
    audioPlayer.dataset.playerStatus = STATUS.isPlaying;
  }

  function controlBtnHandler(e) {
    if (e.detail === 2) {
      // it was a double click
      return;
    }

    // it was a single click
    const playerControl = e.target.closest('[data-track-control]');
    if (playerControl) {
      toggleTrack(playerControl);
    }
  }

  function endHandler() {
    resetAllTracks();

    if (Number(audioPlayer.dataset.currentTrack) < allAudios.length) {
      audioPlayer.dataset.currentTrack = `${Number(audioPlayer.dataset.currentTrack) + 1}`;
    } else {
      audioPlayer.dataset.currentTrack = 1;
      audioPlayer.dataset.playerStatus = STATUS.isPaused;
    }
  }

  function playAudio(audio) {
    const track = document.querySelector(
        `.track[data-track-id="${audioPlayer.dataset.currentTrack}"]`
    );

    if (audio.dataset.trackId !== audioPlayer.dataset.currentTrack) {
      resetAllTracks();
    }

    if (audio.currentTime === audio.duration) {
      audio.currentTime = 0;
    }
    setTimeout(() => {
      audio.play();
    }, 200);

    track.dataset.trackStatus = STATUS.isPlaying;
  }

  function pauseAudio(audio) {
    const track = audio.closest('.track[data-track-id]');

    audio.pause();
    track.dataset.trackStatus = STATUS.isPlaying;
  }

  function pauseAllTracks() {
    allTracks.forEach((track) => {
      track.dataset.trackStatus = STATUS.isPaused;
    });
    allAudios.forEach((audio) => {
      audio.pause();
    });
  }

  function resetAllTracks() {
    allTracks.forEach((track) => {
      track.dataset.trackStatus = STATUS.isPaused;
    });
    allAudios.forEach((audio) => {
      audio.pause();
      audio.currentTime = 0;
    });
  }

  function toggleTrack(control) {
    const track = control.closest('[data-track-id]');
    const trackStatus = track.dataset.trackStatus;
    let audio;

    if (track) {
      audio = document.querySelector(
          `audio[data-track-id="${track.dataset.trackId}"]`
      );
    }
    pauseAllTracks(allTracks);

    if (trackStatus === STATUS.isPaused) {
      playAudio(audio);
      audioPlayer.dataset.playerStatus = STATUS.isPlaying;
    } else {
      pauseAudio(audio);
      audioPlayer.dataset.playerStatus = STATUS.isPaused;
    }

    audioPlayer.dataset.currentTrack = track.dataset.trackId;
  }

  audioPlayer.addEventListener('click', controlBtnHandler);

  const currentTrackHandler = () => {
    if (audioPlayer.dataset.playerStatus === STATUS.isPlaying) {
      pauseAllTracks(allTracks);
      const audio = document.querySelector(
          `audio[data-track-id="${audioPlayer.dataset.currentTrack}"]`
      );
      playAudio(audio);
    }
    if (audioPlayer.dataset.playerStatus === STATUS.isPaused) {
      pauseAllTracks(allTracks);
    }
  };

  const playerObserver = new MutationObserver(currentTrackHandler);
  const config = {attributes: true};

  playerObserver.observe(audioPlayer, config);

  allAudios.forEach((audio) => {
    audio.addEventListener('ended', endHandler);
  });
  startBtn.addEventListener('click', startListenAlbum);
};

export {initAudioPlayer};
